export * from "./software-guard-pricing-page.template";
export { SoftwareGuardPricingPageTemplate as default } from "./software-guard-pricing-page.template";
